export default __webpack_public_path__ + "static/media/IN.e27d1267.svg";